import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import OrdersTabDesktop from './OrdersTabDesktop';
import OrdersTabMobile from './OrdersTabMobile';

const OrdersTab = ({ orders }) => {
  const history = useHistory();
  const location = useLocation();
  
  const requestedStatus = queryString.parse(location.search).orderStatus || null;
  const [showFilters, setShowFilters] = useState(false);
  const visibleOrders = (orders || []).filter(order => {
    if (order.totalQuantity != null) return Number(order.totalQuantity) > 0;
    if (order.distinctProductsCount != null) return Number(order.distinctProductsCount) > 0;
    return true;
  });
  const availableStatuses = [...new Set(visibleOrders.map(order => order.orderStatus))].filter(Boolean);
  const selectedStatus = availableStatuses.includes(requestedStatus) ? requestedStatus : null;
  const filteredOrders = selectedStatus
    ? visibleOrders.filter(order => order.orderStatus === selectedStatus)
    : visibleOrders;

  // Список всіх можливих статусів
  const allOrderStatuses = [
    { value: 'Очікує на обробку', label: 'Очікує на обробку' },
    { value: 'Підтверджено, очікує на пакування', label: 'Підтверджено, очікує на пакування' },
    { value: 'Упаковано, очікує на відправлення', label: 'Упаковано, очікує на відправлення' },
    { value: 'Відправлено', label: 'Відправлено' },
    { value: 'Передзамовлення', label: 'Передзамовлення' },
    { value: 'Відкладено', label: 'Відкладено' },
    { value: 'Відмінено', label: 'Відмінено' },
    { value: 'Повернено', label: 'Повернено' }
  ];

  // Фільтруємо список статусів, залишаючи тільки ті, які є в замовленнях
  const orderStatuses = [
    { value: null, label: 'Всі' },
    ...allOrderStatuses.filter(status => availableStatuses.includes(status.value))
  ];
  const showFiltersSection = orderStatuses.length > 2; // не показувати фільтри, якщо лише 1 статус

  const handleStatusFilterChange = (status) => {
    const currentQueryParams = queryString.parse(location.search);
    const newParams = { ...currentQueryParams, tab: 'orders' };
    if (status) {
      newParams.orderStatus = status;
    } else {
      delete newParams.orderStatus;
    }
    const params = queryString.stringify(newParams);
    history.push(`/user/personal-cabinet?${params}`);
  };

  const getStatusButtonClass = (statusValue) => {
    const isActive = selectedStatus === statusValue;
    if (statusValue === null) {
      return `btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-primary'} mb-2 mb-md-0`;
    }
    // Кольори залежно від статусу
    const statusColors = {
      'Очікує на обробку': { active: 'btn-primary', inactive: 'btn-outline-primary' },
      'Підтверджено, очікує на пакування': { active: 'btn-info', inactive: 'btn-outline-info' },
      'Упаковано, очікує на відправлення': { active: 'btn-info', inactive: 'btn-outline-info' },
      'Відправлено': { active: 'btn-success', inactive: 'btn-outline-success' },
      'Передзамовлення': { active: 'btn-success', inactive: 'btn-outline-success' },
      'Відкладено': { active: 'btn-warning', inactive: 'btn-outline-warning' },
      'Відмінено': { active: 'btn-danger', inactive: 'btn-outline-danger' },
      'Повернено': { active: 'btn-danger', inactive: 'btn-outline-danger' }
    };
    const colors = statusColors[statusValue] || { active: 'btn-secondary', inactive: 'btn-outline-secondary' };
    return `btn btn-sm ${isActive ? colors.active : colors.inactive} mb-2 mb-md-0`;
  };

  return (
    <div className="row personal-cabinet-tab-content">
      <div className='col'>
        <h5 className='mb-2 text-center d-flex align-items-center justify-content-center' style={{ gap: '0.5rem' }}>
          {showFiltersSection && (
            <i 
              className={`bi bi-funnel${showFilters ? '-fill' : ''}`}
              onClick={() => setShowFilters(!showFilters)}
              style={{ 
                fontSize: '1.1rem',
                cursor: 'pointer',
                color: showFilters ? '#007bff' : '#6c757d',
                transition: 'color 0.2s ease'
              }}
              title='Фільтр по статусу'
              onMouseEnter={(e) => e.currentTarget.style.color = '#007bff'}
              onMouseLeave={(e) => e.currentTarget.style.color = showFilters ? '#007bff' : '#6c757d'}
            />
          )}
          <b>Мої замовлення:</b>
        </h5>
        {visibleOrders.length > 0 ? (
          <>
            {showFiltersSection && showFilters && (
              <div className='mb-3 d-flex flex-wrap justify-content-center' style={{ gap: '0.5rem' }}>
                {orderStatuses.map((status) => (
                  <button
                    key={status.value || 'all'}
                    type='button'
                    className={getStatusButtonClass(status.value)}
                    onClick={() => handleStatusFilterChange(status.value)}
                  >
                    {status.label}
                  </button>
                ))}
              </div>
            )}
            {showFiltersSection && selectedStatus && (
              <div className='mb-3 d-flex flex-wrap align-items-center justify-content-center' style={{ gap: '0.5rem' }}>
                <span className='font-weight-bold' style={{ fontSize: '0.875rem' }}>Активний фільтр:</span>
                <span className='badge badge-dark d-inline-flex align-items-center' style={{ fontSize: '0.875rem', padding: '0.35rem 0.5rem', fontWeight: 'bold' }}>
                  {orderStatuses.find(s => s.value === selectedStatus)?.label || selectedStatus}
                  <button
                    type='button'
                    className='btn p-0 ml-2 border-0 bg-transparent'
                    onClick={() => handleStatusFilterChange(null)}
                    title='Очистити фільтр'
                    style={{ fontSize: '0.875rem', color: 'inherit', lineHeight: '1', padding: 0, cursor: 'pointer', opacity: 0.8 }}
                    onMouseEnter={e => { e.currentTarget.style.opacity = '1'; }}
                    onMouseLeave={e => { e.currentTarget.style.opacity = '0.8'; }}
                  >
                    <i className='bi bi-x' style={{ fontWeight: 'bold' }}></i>
                  </button>
                </span>
              </div>
            )}
            {/* Desktop view */}
            <div className="d-none d-lg-block">
              <OrdersTabDesktop orders={filteredOrders} />
            </div>

            {/* Mobile view */}
            <div className="d-lg-none">
              <OrdersTabMobile orders={filteredOrders} />
            </div>
          </>
        ) : (
          <div className="text-center mt-4">
            <p>У вас ще немає замовлень</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersTab;
